import { render } from "./MainProductTraking.vue?vue&type=template&id=2eb45c6a&scoped=true"
import script from "./MainProductTraking.vue?vue&type=script&lang=js"
export * from "./MainProductTraking.vue?vue&type=script&lang=js"

import "./MainProductTraking.vue?vue&type=style&index=0&id=2eb45c6a&scoped=true&lang=css"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb45c6a"]])

export default __exports__